import isValidVar from './isValidVar';

/**
  * @memberof checkVarType
  * @name isNumber
  * Check if a variable is a number
  * @param {any} x variable to be checked
  * @returns {boolean} is this variable a number?
*/
const isNumber = (x) => isValidVar(x) && !Number.isNaN(Number(x));

export default isNumber;
